import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SubmitButtonWrapper } from '../styled/Form/SubmitButtonWrapper';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    SelectChangeEvent,
    Typography,
} from '@mui/material';
import TextFieldStyled from '../shared/TextFieldStyled';
import { FormControlsWrapper } from '../styled/Form/FormControlsWrapper';
import { AddressesFormProps } from '../../models/Addresses';
import SelectStyled from '../shared/SelectStyled';
import AddressService from 'services/AddressService';
import SnackbarUtils from '../../utils/SnackbarUtils';
import { PATTERNS } from '../../utils/constans/constans';

export const CreateNewAddresses: React.FC<AddressesFormProps> = (
    props: AddressesFormProps
) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>();
    const {submitForm} = props
    const [submitIsLoading, setSubmitIsLoading] = useState(false);
    // const { countries } = useCountriesSWR();
    const [country, setCountry] = useState('HU');
    // const [billingCountry, setBillingCountry] = useState('HU');
    // const [sameAsShipping, setSameAsShipping] = useState(true);
    const { t } = useTranslation();

    // const handleCountryChange = (
    //     type: 'shipping' | 'billing',
    //     event: SelectChangeEvent
    // ) => {
    //     type === 'shipping'
    //         ? setCountry(event.target.value as string)
    //         : setBillingCountry(event.target.value as string);
    // };

    const handleCountryChange = (
        type: 'shipping',
        event: SelectChangeEvent
    ) => {
        setCountry(event.target.value as string);
    };

    const getTranslate = (key) => {
        return t(key).toString();
    };

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setSubmitIsLoading(true);
        submitForm(data);
    };

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                {/* ----- Shipping ----- */}
                <Typography paragraph>
                    {t('PROFILE.PROFILE_DIALOG.FORM_CONTENT.SHIPPING_CONTENT')}
                </Typography>
                <FormControlsWrapper>
                    {/* Postcode */}
                    <FormControl fullWidth>
                        <TextFieldStyled
                            label={t(
                                'PROFILE.PROFILE_DIALOG.FORM_CONTENT.POSTAL_CODE'
                            ).toString()}
                            error={!!errors.postcode}
                            {...register('postcode', {
                                required: t(
                                    'FORM_VALIDATION_ERROR.REQUIRED'
                                ).toString(),
                            })}
                            helperText={
                                errors.postcode
                                    ? getTranslate(errors.postcode.message)
                                    : ' '
                            }
                        />
                    </FormControl>
                    {/* City */}
                    <FormControl fullWidth>
                        <TextFieldStyled
                            label={t(
                                'PROFILE.PROFILE_DIALOG.FORM_CONTENT.CITY'
                            ).toString()}
                            error={!!errors.city}
                            {...register('city', {
                                required: t(
                                    'FORM_VALIDATION_ERROR.REQUIRED'
                                ).toString(),
                            })}
                            helperText={
                                errors.city
                                    ? getTranslate(errors.city.message)
                                    : ' '
                            }
                        />
                    </FormControl>
                </FormControlsWrapper>
                {/* Address 1 */}
                <FormControl fullWidth>
                    <TextFieldStyled
                        label={t(
                            'PROFILE.PROFILE_DIALOG.FORM_CONTENT.ADDRESS1'
                        ).toString()}
                        error={!!errors.address1}
                        {...register('address1', {
                            required: t(
                                'FORM_VALIDATION_ERROR.REQUIRED'
                            ).toString(),
                        })}
                        helperText={
                            errors.address1
                                ? getTranslate(errors.address1.message)
                                : ' '
                        }
                    />
                </FormControl>
                {/* Address 2 */}
                <FormControl fullWidth>
                    <TextFieldStyled
                        label={t(
                            'PROFILE.PROFILE_DIALOG.FORM_CONTENT.ADDRESS2'
                        ).toString()}
                        {...register('address2')}
                        helperText={' '}
                    />
                </FormControl>
                {/* Country */}
                <FormControl fullWidth variant="filled">
                    <InputLabel
                        sx={{
                            color: '#999999',
                        }}
                    >
                        {t(
                            'PROFILE.PROFILE_DIALOG.FORM_CONTENT.COUNTRY'
                        ).toString()}
                    </InputLabel>
                    <SelectStyled
                        label={t('REGISTRATION_FORM_FIELDS.COUNTRY').toString()}
                        {...register('country', {
                            required: t(
                                'FORM_VALIDATION_ERROR.REQUIRED'
                            ).toString(),
                            onChange: (e) => handleCountryChange('shipping', e),
                        })}
                        value={country}
                    >
                        {/*{countries &&*/}
                        {/*    countries.map((countryCode) => (*/}
                        {/*        <MenuItem key={countryCode} value={countryCode}>*/}
                        {/*            {t('COUNTRIES.' + countryCode)}*/}
                        {/*        </MenuItem>*/}
                        {/*    ))}*/}
                        <MenuItem value={'HU'}>
                            {t('COUNTRIES.HU', { ns: 'countries' })}
                        </MenuItem>
                    </SelectStyled>
                    <FormHelperText error={!!errors.country}>
                        &#8203;
                        {errors.country && getTranslate(errors.country.message)}
                    </FormHelperText>
                </FormControl>
                {/* Phone */}
                <FormControl fullWidth>
                    <TextFieldStyled
                        label={t(
                            'PROFILE.PROFILE_DIALOG.FORM_CONTENT.PHONE'
                        ).toString()}
                        error={!!errors.phone}
                        {...register('phone', {
                            required: t(
                                'FORM_VALIDATION_ERROR.REQUIRED'
                            ).toString(),
                            pattern: {
                                value: PATTERNS.PHONE_NUMBER,
                                message: t(
                                    'FORM_VALIDATION_ERROR.PHONE'
                                ).toString(),
                            },
                        })}
                        helperText={
                            errors.phone
                                ? getTranslate(errors.phone.message)
                                : ' '
                        }
                    />
                </FormControl>
                {/*/!* Same as *!/*/}
                {/*<FormControl fullWidth>*/}
                {/*    <FormControlLabel*/}
                {/*        control={*/}
                {/*            <Checkbox*/}
                {/*                {...register('same_as_shipping')}*/}
                {/*                checked={sameAsShipping}*/}
                {/*                onChange={(e) =>*/}
                {/*                    setSameAsShipping(e.target.checked)*/}
                {/*                }*/}
                {/*            />*/}
                {/*        }*/}
                {/*        label={t('PROFILE.PROFILE_DIALOG.FORM_CONTENT.SAME_AS')}*/}
                {/*    />*/}
                {/*</FormControl>*/}
                {/* ----- BILLING ----- */}
                {/*{!sameAsShipping && (*/}
                {/*    <>*/}
                {/*        <Typography paragraph>*/}
                {/*            {t(*/}
                {/*                'PROFILE.PROFILE_DIALOG.FORM_CONTENT.BILLING_CONTENT'*/}
                {/*            )}*/}
                {/*        </Typography>*/}
                {/*        <FormControlsWrapper>*/}
                {/*            /!* Postcode *!/*/}
                {/*            <FormControl fullWidth>*/}
                {/*                <TextFieldStyled*/}
                {/*                    label={t(*/}
                {/*                        'PROFILE.PROFILE_DIALOG.FORM_CONTENT.POSTAL_CODE'*/}
                {/*                    ).toString()}*/}
                {/*                    error={!!errors.billing_postcode}*/}
                {/*                    {...register('billing_postcode', {*/}
                {/*                        required: t(*/}
                {/*                            'FORM_VALIDATION_ERROR.REQUIRED'*/}
                {/*                        ).toString(),*/}
                {/*                    })}*/}
                {/*                    helperText={*/}
                {/*                        errors.billing_postcode*/}
                {/*                            ? getTranslate(*/}
                {/*                                  errors.billing_postcode*/}
                {/*                                      .message*/}
                {/*                              )*/}
                {/*                            : ' '*/}
                {/*                    }*/}
                {/*                />*/}
                {/*            </FormControl>*/}
                {/*            /!* City *!/*/}
                {/*            <FormControl fullWidth>*/}
                {/*                <TextFieldStyled*/}
                {/*                    label={t(*/}
                {/*                        'PROFILE.PROFILE_DIALOG.FORM_CONTENT.CITY'*/}
                {/*                    ).toString()}*/}
                {/*                    error={!!errors.billing_city}*/}
                {/*                    {...register('billing_city', {*/}
                {/*                        required: t(*/}
                {/*                            'FORM_VALIDATION_ERROR.REQUIRED'*/}
                {/*                        ).toString(),*/}
                {/*                    })}*/}
                {/*                    helperText={*/}
                {/*                        errors.billing_city*/}
                {/*                            ? getTranslate(*/}
                {/*                                  errors.billing_city.message*/}
                {/*                              )*/}
                {/*                            : ' '*/}
                {/*                    }*/}
                {/*                />*/}
                {/*            </FormControl>*/}
                {/*        </FormControlsWrapper>*/}
                {/*        /!* Address 1 *!/*/}
                {/*        <FormControl fullWidth>*/}
                {/*            <TextFieldStyled*/}
                {/*                label={t(*/}
                {/*                    'PROFILE.PROFILE_DIALOG.FORM_CONTENT.ADDRESS1'*/}
                {/*                ).toString()}*/}
                {/*                error={!!errors.billing_address1}*/}
                {/*                {...register('billing_address1', {*/}
                {/*                    required: t(*/}
                {/*                        'FORM_VALIDATION_ERROR.REQUIRED'*/}
                {/*                    ).toString(),*/}
                {/*                })}*/}
                {/*                helperText={*/}
                {/*                    errors.billing_address1*/}
                {/*                        ? getTranslate(*/}
                {/*                              errors.billing_address1.message*/}
                {/*                          )*/}
                {/*                        : ' '*/}
                {/*                }*/}
                {/*            />*/}
                {/*        </FormControl>*/}
                {/*        /!* Address 2 *!/*/}
                {/*        <FormControl fullWidth>*/}
                {/*            <TextFieldStyled*/}
                {/*                label={t(*/}
                {/*                    'PROFILE.PROFILE_DIALOG.FORM_CONTENT.ADDRESS2'*/}
                {/*                ).toString()}*/}
                {/*                {...register('billing_address2')}*/}
                {/*                helperText={' '}*/}
                {/*            />*/}
                {/*        </FormControl>*/}
                {/*        /!* Billing Country *!/*/}
                {/*        <FormControl fullWidth variant="filled">*/}
                {/*            <InputLabel*/}
                {/*                sx={{*/}
                {/*                    color: '#999999',*/}
                {/*                }}*/}
                {/*            >*/}
                {/*                {t(*/}
                {/*                    'REGISTRATION_FORM_FIELDS.COUNTRY'*/}
                {/*                ).toString()}*/}
                {/*            </InputLabel>*/}
                {/*            <SelectStyled*/}
                {/*                label={t(*/}
                {/*                    'REGISTRATION_FORM_FIELDS.COUNTRY'*/}
                {/*                ).toString()}*/}
                {/*                {...register('billing_country', {*/}
                {/*                    required: t(*/}
                {/*                        'FORM_VALIDATION_ERROR.REQUIRED'*/}
                {/*                    ).toString(),*/}
                {/*                    onChange: (e) =>*/}
                {/*                        handleCountryChange('billing', e),*/}
                {/*                })}*/}
                {/*                value={billingCountry}*/}
                {/*            >*/}
                {/*                /!*{countries &&*!/*/}
                {/*                /!*    countries.map((countryCode) => (*!/*/}
                {/*                /!*        <MenuItem key={countryCode} value={countryCode}>*!/*/}
                {/*                /!*            {t('COUNTRIES.' + countryCode)}*!/*/}
                {/*                /!*        </MenuItem>*!/*/}
                {/*                /!*    ))}*!/*/}
                {/*                <MenuItem value={'HU'}>*/}
                {/*                    {t('COUNTRIES.HU', { ns: 'countries' })}*/}
                {/*                </MenuItem>*/}
                {/*            </SelectStyled>*/}
                {/*            <FormHelperText error={!!errors.billing_country}>*/}
                {/*                &#8203;*/}
                {/*                {errors.billing_country &&*/}
                {/*                    getTranslate(*/}
                {/*                        errors.billing_country.message*/}
                {/*                    )}*/}
                {/*            </FormHelperText>*/}
                {/*        </FormControl>*/}
                {/*        /!* Phone *!/*/}
                {/*        <FormControl fullWidth>*/}
                {/*            <TextFieldStyled*/}
                {/*                label={t(*/}
                {/*                    'PROFILE.PROFILE_DIALOG.FORM_CONTENT.PHONE'*/}
                {/*                ).toString()}*/}
                {/*                error={!!errors.billing_phone}*/}
                {/*                {...register('billing_phone', {*/}
                {/*                    required: t(*/}
                {/*                        'FORM_VALIDATION_ERROR.REQUIRED'*/}
                {/*                    ).toString(),*/}
                {/*                })}*/}
                {/*                helperText={*/}
                {/*                    errors.billing_phone*/}
                {/*                        ? getTranslate(*/}
                {/*                              errors.billing_phone.message*/}
                {/*                          )*/}
                {/*                        : ' '*/}
                {/*                }*/}
                {/*            />*/}
                {/*        </FormControl>*/}
                {/*    </>*/}
                {/*)}*/}
                <SubmitButtonWrapper>
                    <PrimaryBtn type="submit" disabled={submitIsLoading}>
                        {t(
                            'PROFILE.PROFILE_DIALOG.FORM_CONTENT.SEND'
                        ).toString()}
                    </PrimaryBtn>
                </SubmitButtonWrapper>
            </form>
        </>
    );
};

type FormValues = {
    phone: string;
    country: string;
    postcode: string;
    city: string;
    address1: string;
    address2: string;
    same_as_shipping: boolean;
    billing_country: string;
    billing_postcode: string;
    billing_city: string;
    billing_address1: string;
    billing_address2: string;
    billing_phone: string;
};
